import React from "react";
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad'
import { Box, Typography } from "@mui/material";

const BlogCard = () => {
  return (
    <Box
      height="400px"
      width="30%"
      minWidth="280px"
      mr={2}
      mb={2}
      boxShadow="0 0 5px rgb(209, 209, 209)"
      borderRadius="5px"
      overflow="hidden"
    >
      <Box height="50%">
        <ImgLazyLoad>
          <img
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
            src="https://playuganda.com/wp-content/uploads/2020/12/profile-pic.jpg"
            alt="blog"
          />
        </ImgLazyLoad>
      </Box>
      <Box height="50%" py={1}>
        <Box px={2} py={2}>
          <Box pb={2}>
            <Typography variant="h6" style={{ fontWeight: "bold" }}>
              Blog Title
            </Typography>
            <Typography variant="subtitle2">March 14, 2020</Typography>
          </Box>

          <Typography variant="body2">
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Id laborum
            architecto quisquam quibusdam placeat rem!
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default BlogCard;
